import { EmployeeMap, TeamMap } from '../api/model';
import { TeamDuty, TeamShift } from '@pdcplan/shared/api/TeamPlan';

import { ActiveOfferView } from './ShiftViewEnums';
import { ExchangeCandidateFilterEnum } from '@pdcplan/shared/enums';
import OfferViewDetail from './OfferViewDetail';
import OfferViewGroupList from './OfferViewGroupList';
import { setOfferViewOpen } from './ShiftViewActions';
import { useState } from 'react';

type Props = {
  shift: TeamShift;
  teams: TeamMap;
  teamId: string;
  possibleCandidateFilters: ExchangeCandidateFilterEnum[];
  defaultExchangeCandidateFilter: ExchangeCandidateFilterEnum;
  offerViewActiveView: ActiveOfferView;
  dutyLines: TeamDuty[];
  employees: EmployeeMap;
  onBackClick: () => void;
  rejectOffer: () => void;
  acceptOffer: (
    teamIdList: string[],
    candidateFilter: ExchangeCandidateFilterEnum,
    remark: string
  ) => void;
  setActiveOfferView: (activeOfferView: ActiveOfferView) => void;
};

const OfferView = ({
  shift,
  teams,
  possibleCandidateFilters,
  defaultExchangeCandidateFilter,
  offerViewActiveView,
  teamId,
  dutyLines,
  employees,
  acceptOffer,
  setActiveOfferView,
}: Props) => {
  const [expandedAccordionItems, setExpandedAccordionItems] = useState<
    string[]
  >([]);
  const [selectedGroups, setSelectedGroups] = useState<string[]>([]);

  const employee = employees[shift.personId];
  const formerEmployee = employees[shift.formerPersonId];

  return (
    <>
      <OfferViewGroupList
        setActiveOfferView={setActiveOfferView}
        show={offerViewActiveView === ActiveOfferView.OfferViewList}
        shift={shift}
        teams={teams}
        teamId={teamId}
        onBackClick={() => {
          setSelectedGroups([]);
          setActiveOfferView(ActiveOfferView.None);
        }}
        possibleCandidateFilters={possibleCandidateFilters}
        defaultExchangeCandidateFilter={defaultExchangeCandidateFilter}
        rejectOffer={() => {
          setOfferViewOpen(false);
        }}
        expandedAccordionItems={expandedAccordionItems}
        selectedGroups={selectedGroups}
        setExpandedAccordionItems={setExpandedAccordionItems}
        setSelectedGroups={setSelectedGroups}
      />
      <OfferViewDetail
        show={offerViewActiveView === ActiveOfferView.OfferView}
        onBackClick={() => {
          setActiveOfferView(ActiveOfferView.OfferViewList);
        }}
        shift={shift}
        dutyLines={dutyLines}
        selectedGroups={selectedGroups}
        teams={teams}
        possibleCandidateFilters={possibleCandidateFilters}
        defaultExchangeCandidateFilter={defaultExchangeCandidateFilter}
        onOfferClick={(candidateFilter, remark) => {
          acceptOffer(selectedGroups, candidateFilter, remark);
        }}
        employee={employee}
        formerEmployee={formerEmployee}
      />
    </>
  );
};

export default OfferView;
